import {IMenuData, ISubMenuData} from '@/@types/global'

export const managerItem: ISubMenuData[] = [
  {
    name: '账号管理',
    id: 'zh',
    isActive: false,
    path: '/account/index'
  },
  {
    name: '用户余额',
    id: 'ye',
    isActive: false,
    path: '/account/balance'
  },
  {
    name: '用户充值',
    id: 'cz',
    isActive: false,
    path: '/account/charge'
  },
  {
    name: '消费明细',
    id: 'mx',
    isActive: false,
    path: '/account/detail'
  },
  {
    name: '操作日志',
    id: 'log',
    isActive: false,
    path: '/account/logs'
  }
]
export const customItem: ISubMenuData[] = [
  {
    name: '消费明细',
    id: 'cmx',
    isActive: false,
    path: '/bill/index'
  },
  {
    name: '余额消费',
    id: 'cye',
    isActive: false,
    path: '/bill/remain'
  }
]
export const filterItem: ISubMenuData[] = [
  {
    name: '手机检测',
    id: 'fphone',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Line',
    id: 'fline',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'WhatsApp',
    id: 'fws',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Telegram',
    id: 'ftg',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Zalo',
    id: 'fzalo',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Signal',
    id: 'fsignal',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'skype',
    id: 'fskype',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Facebook',
    id: 'ffb',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Instagram',
    id: 'fins',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'TikTok',
    id: 'ftiktok',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Binance',
    id: 'fbinance',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Linkedin',
    id: 'flinkedin',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Microsoft',
    id: 'fms',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Twitter',
    id: 'ftwitter',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Amazon',
    id: 'famazon',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Viber',
    id: 'fviber',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'SnapChat',
    id: 'fsnapchat',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'KakaoTalk',
    id: 'fkakao',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Wish',
    id: 'fwish',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: 'Botim',
    id: 'fbotim',
    isActive: false,
    path: '/filterManager/index',
    icon: 'botim'
  },
  {
    name: 'OKX',
    id: 'fokx',
    isActive: false,
    path: '/filterManager/index',
    icon: 'okx'
  },
  {
    name: 'HTX',
    id: 'fhtx',
    isActive: false,
    path: '/filterManager/index',
    icon: 'htx'
  },
  {
    name: 'Bybit',
    id: 'fbybit',
    isActive: false,
    path: '/filterManager/index',
    icon: 'bybit'
  },
  {
    name: 'Mint',
    id: 'fmint',
    isActive: false,
    path: '/filterManager/index',
    icon: 'mint'
  },
  {
    name: 'Gate',
    id: 'fgate',
    isActive: false,
    path: '/filterManager/index',
    icon: 'gate'
  },
  {
    name: '活动专区',
    id: 'fevent',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: '盲盒专区',
    id: 'fblack',
    isActive: false,
    path: '/filterManager/index'
  },
  {
    name: '成品代筛',
    id: 'fagent',
    isActive: false,
    path: '/filterManager/index'
  }
]
export const contentItem: ISubMenuData[] = [
  {
    name: '内容管理',
    id: 'notice',
    isActive: false,
    path: '/content/notice'
  },
  {
    name: '留言管理',
    id: 'comment',
    isActive: false,
    path: '/content/comment'
  }
]
export const extraMenuData: IMenuData[] = [
  {
    name: 'Binance',
    id: 'binance',
    icon: 'binance',
    isActive: false,
    children: []
  },
  {
    name: 'Linkedin',
    id: 'linkedin',
    icon: 'linkedin',
    isActive: false,
    children: []
  },
  {
    name: 'Microsoft',
    id: 'ms',
    icon: 'microsoft',
    isActive: false,
    children: []
  },
  {
    name: 'Twitter',
    id: 'twitter',
    icon: 'twitter',
    isActive: false,
    children: []
  },
  {
    name: 'Amazon',
    id: 'amazon',
    icon: 'amazon',
    isActive: false,
    children: []
  },
  {
    name: 'Viber',
    id: 'viber',
    icon: 'viber',
    isActive: false,
    children: []
  },
  {
    name: 'SnapChat',
    id: 'snapchat',
    icon: 'snapchat',
    isActive: false,
    children: []
  },
  {
    name: 'KakaoTalk',
    id: 'kakao',
    icon: 'kakao',
    isActive: false,
    children: []
  },
  {
    name: 'Wish',
    id: 'wish',
    icon: 'wish',
    isActive: false,
    children: []
  },
  {
    name: 'Botim',
    id: 'botim',
    icon: 'botim',
    isActive: false,
    children: []
  },
  {
    name: 'TikTok',
    id: 'tiktok',
    icon: 'tiktok',
    isActive: false,
    children: []
  },
  {
    name: '成品代筛',
    id: 'agent',
    icon: 'myFilter',
    isActive: false,
    children: []
  }
]

export const menuData1: IMenuData[] = [
  {
    name: '个人中心',
    id: 'homePage',
    icon: 'homePage',
    isActive: false,
    children: [
      {
        name: '平台主页',
        id: 'home',
        isActive: false,
        path: '/'
      },
      {
        name: '消费明细',
        id: 'cmx',
        isActive: false,
        path: '/bill/index'
      },
      {
       name: '产品一览',
       id: 'cpyl',
       isActive: false,
       path: '/bill/product'
       },
      {
        name: '充值记录',
        id: 'ccz',
        isActive: false,
        path: '/bill/charge'
      },
      {
        name: '我的留言',
        id: 'comment',
        isActive: false,
        path: '/content/comment'
      }
    ]
  },
  {
    name: '个人中心',
    id: 'agency',
    icon: 'homePage',
    isActive: false,
    children: [
      {
        name: '首页',
        id: 'homePage',
        isActive: false,
        path: '/homePage'
      },
      {
        name: '我的客户',
        id: 'subUser',
        isActive: false,
        path: '/agency/subUser'
      },
      {
        name: '佣金结算',
        id: 'settlement',
        isActive: false,
        path: '/agency/settlement'
      }, 
      {
        name: '消费明细',
        id: 'cmx',
        isActive: false,
        path: '/bill/index'
      },
      {
        name: '充值记录',
        id: 'ccz',
        isActive: false,
        path: '/bill/charge'
      },
      {
        name: '我的留言',
        id: 'comment',
        isActive: false,
        path: '/content/comment'
      }
    ]
  },
  {
    name: '号码生成',
    id: 'tools',
    icon: 'tools',
    isActive: false,
    children: [
      {
        name: '实时号段生成',
        id: 'section',
        isActive: false,
        path: '/tools/section'
      },
      {
        name: '自动号码生成',
        id: 'haoma',
        isActive: false,
        path: '/tools/haoma'
      }
    ]
  },
  {
    name: '用户管理',
    id: 'manager',
    icon: 'userManager',
    isActive: false,
    children: [
      {
        name: '账号管理',
        id: 'zh',
        isActive: false,
        path: '/account/index'
      },
      {
        name: '用户余额',
        id: 'ye',
        isActive: false,
        path: '/account/balance'
      },
      {
        name: '充值扣缴',
        id: 'cz',
        isActive: false,
        path: '/account/charge'
      },
      {
        name: '消费明细',
        id: 'mx',
        isActive: false,
        path: '/account/detail'
      },
      {
        name: '佣金结算',
        id: 'settlement',
        isActive: false,
        path: '/agency/settlement'
      },
      {
        name: '自动充值订单',
        id: 'zdcz',
        isActive: false,
        path: '/account/autoCharge'
      },
      {
        name: '自动充值规则',
        id: 'czgz',
        isActive: false,
        path: '/account/chargeRule'
      },
      {
        name: '菜单权限',
        id: 'ma',
        isActive: false,
        path: '/account/menuAuth'
      },
      {
        name: '内容管理',
        id: 'nr',
        isActive: false,
        path: '/content/notice'
      },
      {
        name: '操作日志',
        id: 'log',
        isActive: false,
        path: '/account/logs'
      }
    ]
  },
  // 其他类型菜单
  // {
  //   name: '筛选管理',
  //   id: 'filterManager',
  //   icon: 'tools',
  //   isActive: false,
  //   children: [],
  // },
]

// 菜单数据以下为准
export const menuData: IMenuData[] = [
  {
    name: '首页',
    id: 'homePage',
    icon: 'homePage',
    isActive: false,
    children: [
      {
        name: '首页',
        id: 'home',
        isActive: false,
        path: '/'
      },
      {
        name: '消费明细',
        id: 'cmx',
        isActive: false,
        path: '/bill/index'
      },
      //{
      //  name: '账户余额',
      //  id: 'cye',
      //  isActive: false,
      //  path: '/bill/remain'
      //  },
      {
        name: '充值记录',
        id: 'ccz',
        isActive: false,
        path: '/bill/charge'
      },
      {
        name: '我的留言',
        id: 'comment',
        isActive: false,
        path: '/content/comment'
      }
    ]
  },
  {
    name: '号码生成',
    id: 'tools',
    icon: 'tools',
    isActive: false,
    children: [
      {
        name: '实时号段生成',
        id: 'section',
        isActive: false,
        path: '/tools/section'
      },
      {
        name: '自动号码生成',
        id: 'haoma',
        isActive: false,
        path: '/tools/haoma'
      }
    ]
  },
  {
    name: '用户管理',
    id: 'manager',
    icon: 'userManager',
    isActive: false,
    children: [
      {
        name: '账号管理',
        id: 'zh',
        isActive: false,
        path: '/account/index'
      },
      {
        name: '用户余额',
        id: 'ye',
        isActive: false,
        path: '/account/balance'
      },
      {
        name: '用户充值',
        id: 'cz',
        isActive: false,
        path: '/account/charge'
      },
      {
        name: '消费明细',
        id: 'mx',
        isActive: false,
        path: '/account/detail'
      },
      {
        name: '自动充值订单',
        id: 'zdcz',
        isActive: false,
        path: '/account/autoCharge'
      },
      {
        name: '自动充值规则',
        id: 'czgz',
        isActive: false,
        path: '/account/chargeRule'
      },
      {
        name: '菜单权限',
        id: 'ma',
        isActive: false,
        path: '/account/menuAuth'
      },
      {
        name: '内容管理',
        id: 'nr',
        isActive: false,
        path: '/content/notice'
      },
      {
        name: '操作日志',
        id: 'log',
        isActive: false,
        path: '/account/logs'
      }
    ]
  },
  // 其他类型菜单
  {
    name: '筛选管理',
    id: 'filterManager',
    icon: 'tools',
    isActive: false,
    children: filterItem,
  },
  {
    name: '手机检测',
    id: 'phone',
    icon: 'phone',
    isActive: false,
    children: []
  },
  {
    name: 'WhatsApp',
    id: 'ws',
    icon: 'whatsapp',
    isActive: false,
    children: []
  },
  {
    name: 'LinkedIn',
    id: 'linkedin',
    icon: 'linkedin',
    isActive: false,
    children: []
  },
  {
    name: 'Telegram',
    id: 'tg',
    icon: 'telegram',
    isActive: false,
    children: []
  },
  {
    name: 'Line',
    id: 'line',
    icon: 'line',
    isActive: false,
    children: []
  },
  {
    name: 'Facebook',
    id: 'fb',
    icon: 'facebook',
    isActive: false,
    children: []
  },
  {
    name: 'Instagram',
    id: 'ins',
    icon: 'instagram',
    isActive: false,
    children: []
  },
  {
    name: 'TikTok',
    id: 'tiktok',
    icon: 'tiktok',
    isActive: false,
    children: []
  },
  {
    name: 'Zalo',
    id: 'zalo',
    icon: 'zalo',
    isActive: false,
    children: []
  },
  {
    name: 'Twitter',
    id: 'twitter',
    icon: 'twitter',
    isActive: false,
    children: []
  },
  {
    name: 'SnapChat',
    id: 'snapchat',
    icon: 'snapchat',
    isActive: false,
    children: []
  },
  {
    name: 'Amazon',
    id: 'amazon',
    icon: 'amazon',
    isActive: false,
    children: []
  },
  {
    name: 'Binance',
    id: 'binance',
    icon: 'binance',
    isActive: false,
    children: []
  },
  {
    name: 'Microsoft',
    id: 'ms',
    icon: 'microsoft',
    isActive: false,
    children: []
  },
  {
    name: 'Skype',
    id: 'skype',
    icon: 'skype',
    isActive: false,
    children: []
  },
  {
    name: 'Viber',
    id: 'viber',
    icon: 'viber',
    isActive: false,
    children: []
  },
  {
    name: 'KakaoTalk',
    id: 'kakao',
    icon: 'kakao',
    isActive: false,
    children: []
  },
  {
    name: 'Botim',
    id: 'botim',
    icon: 'botim',
    // iconPath: 'botim2.png',
    isActive: false,
    children: []
  },
  {
    name: 'Wish',
    id: 'wish',
    icon: 'wish',
    isActive: false,
    children: []
  },
  {
    name: 'OKX',
    id: 'okx',
    icon: 'okx',
    isActive: false,
    children: []
  },
  {
    name: 'HTX',
    id: 'htx',
    icon: 'htx',
    isActive: false,
    children: []
  },
  {
    name: 'Bybit',
    id: 'bybit',
    icon: 'bybit',
    isActive: false,
    children: []
  },
  {
    name: 'Mint',
    id: 'mint',
    icon: 'mint',
    isActive: false,
    children: []
  },
  {
    name: 'Gate',
    id: 'gate',
    icon: 'gate',
    isActive: false,
    children: []
  },
  {
    name: '活动专区',
    id: 'event',
    icon: 'active_',
    isActive: false,
    children: []
  },
  {
    name: '盲盒专区',
    id: 'black',
    icon: 'blind',
    isActive: false,
    children: []
  },

  //{
  //  name: 'MoMo',
  //  id: 'momo',
  //  icon: 'momo',
  //  isActive: false,
  //  children: []
  //},
  //{
  //  name: '定制成品资源',
  //  id: 'agent',
  //  icon: 'agent',
  //  isActive: false,
  //  children: []
  //}
]
